import { requiredStringValidator } from './requiredStringValidator';

export const passwordValidator = requiredStringValidator.min(10, 'Password must be at least 10 characters');
